/**
 * Supported JavaScript types for type guarding.
 */
export type Types = "number" | "string" | "boolean" | "undefined" | "function" | "object" | "bigint" | "symbol";


/**
 * Generates a standard error message when a value is not of the expected type.
 * 
 * @param guardName - The name of the variable being guarded.
 * @param guardType - The expected type.
 * @returns A formatted error message.
 */
export const notTypeMessage = (guardName: string, guardType: Types): string => (
  `'${guardName}' must be a type of '${guardType}'`
)

/**
 * Throws an error if the provided value is not of the specified type.
 * 
 * @param guardName - The name of the variable being guarded.
 * @param guard - The value to check.
 * @param guardType - The expected type.
 * @throws {Error} Throws an error if `typeof guard` does not equal `guardType`.
 */
export const throwNotType = (guardName: string, guard: any, guardType: Types): void => {
  const isType = typeof guard === guardType;
  if (isType === false) {
    throw new Error(notTypeMessage(guardName, guardType));
  }
}